import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('lc_token');
    const stored = localStorage.getItem('lc_user');
    if (token && stored) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      setUser(JSON.parse(stored));
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const { data } = await axios.post('/api/auth/login', { email, password });
    localStorage.setItem('lc_token', data.token);
    localStorage.setItem('lc_user', JSON.stringify(data.user));
    axios.defaults.headers.common['Authorization'] = `Bearer ${data.token}`;
    setUser(data.user);
  };

  const logout = () => {
    localStorage.removeItem('lc_token');
    localStorage.removeItem('lc_user');
    delete axios.defaults.headers.common['Authorization'];
    setUser(null);
  };

  const hasAccess = (screenKey) => {
    if (!user) return false;
    if (user.is_super_admin) return true;
    return Array.isArray(user.permissions) && user.permissions.includes(screenKey);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading, hasAccess }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);